import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Lock } from 'lucide-react';

/**
 * Wrap an admin route with <PermissionRoute perm="users">. Renders a friendly
 * "no access" screen for authenticated users who lack the permission, and
 * redirects to /admin (login) for unauthenticated visitors.
 */
const PermissionRoute = ({ perm, children }) => {
  const { user, loading, hasPermission } = useAuth();

  if (loading) {
    return <div className="p-8 text-slate-400">Loading…</div>;
  }
  if (!user) return <Navigate to="/admin" replace />;
  if (!hasPermission(perm)) {
    return (
      <div className="p-10 max-w-lg mx-auto text-center" data-testid="permission-denied">
        <div className="w-14 h-14 mx-auto rounded-full bg-red-500/10 flex items-center justify-center mb-4">
          <Lock className="w-7 h-7 text-red-400" />
        </div>
        <h2 className="text-xl font-semibold text-white mb-2">No access</h2>
        <p className="text-slate-400 text-sm">
          Your role ({user.role_label || user.role}) doesn't have access to this section.
          Ask your admin if you think this is wrong.
        </p>
      </div>
    );
  }
  return children;
};

export default PermissionRoute;
